/**
 * Do not edit directly
 * Generated on Fri, 17 Mar 2023 09:07:38 GMT
 */

export const shadows = {
  sm: '0px 0px 10px 0px rgba(191, 191, 191, 0.5)',
  md: '0px 0px 20px 0px rgba(104, 104, 104, 0.3)',
}
